module.exports = __webpack_public_path__ + "media/images/element/24-4950d15d4b1d1767e0f1ea92a13c34d1.svg";